import { FeedQueryParams } from '@/pages/api/map-events/get-incidents-feed.types';
import { IncidentLocations } from '@/pages/api/map-events/incident-locations.types';
import {
  AssetDecisionItem,
  AssetItem,
  IncidentFeedItem,
  IncidentFilterOptions,
  IncidentItem,
  IncidentTagItem,
  IncidentTypeItem,
  OrgParams,
  SeverityItem,
} from '@/server/services/GoogleBigQuery/BigQueryIncidentsClient.types';
import { ROUTE, axiosInstance } from './axiosInstance';

export const mapEvents = {
  getAssets: async ({ orgId }: OrgParams) => {
    const { data } = await axiosInstance.get<AssetItem[]>(ROUTE.MAP_EVENTS.ASSETS, { params: { orgId } });
    return data;
  },

  getAssetDecisions: async ({ orgId, assetId }: OrgParams & { assetId: AssetItem['AssetID'] }) => {
    const { data } = await axiosInstance.get<AssetDecisionItem[]>(ROUTE.MAP_EVENTS.ASSET_DECISIONS, {
      params: { orgId, assetId },
    });
    return data;
  },

  getIncidents: async ({
    orgId,
    limit,
    filters,
  }: OrgParams & { limit?: number | null; filters?: IncidentFilterOptions }) => {
    const params = {
      orgId,
      ...(limit ? { limit } : {}),
      ...(filters ? filters : {}),
    };
    const { data } = await axiosInstance.get<IncidentItem[]>(ROUTE.MAP_EVENTS.INCIDENTS, {
      params,
    });

    return data;
  },

  getIncidentTags: async ({ orgId }: OrgParams): Promise<IncidentTagItem['IncidentTagsName'][]> => {
    const { data } = await axiosInstance.get<IncidentItem['Tags']>(ROUTE.MAP_EVENTS.INCIDENTS_TAGS, {
      params: { orgId },
    });
    return data;
  },

  getIncidentTagColors: async ({ orgId }: OrgParams) => {
    const { data } = await axiosInstance.get<IncidentTagItem[]>(ROUTE.MAP_EVENTS.INCIDENTS_TAG_COLORS, {
      params: { orgId },
    });
    return data;
  },

  getIncidentsFeed: async (params: OrgParams & FeedQueryParams) => {
    const { data } = await axiosInstance.get<IncidentFeedItem[]>(ROUTE.MAP_EVENTS.INCIDENTS_FEED, {
      params,
    });
    return data;
  },

  getIncidentsCount: async ({
    orgId,
    coordBounds,
    filters,
  }: OrgParams & Partial<Pick<FeedQueryParams, 'coordBounds' | 'filters'>>) => {
    const { data } = await axiosInstance.get<{ count: number }>(ROUTE.MAP_EVENTS.INCIDENTS_COUNT, {
      params: { orgId, coordBounds, filters },
    });
    return data;
  },

  getIncidentLocations: async ({ orgId }: OrgParams) => {
    const { data } = await axiosInstance.get<IncidentLocations>(ROUTE.MAP_EVENTS.INCIDENT_LOCATIONS, {
      params: { orgId },
    });
    return data;
  },

  getIncidentTypes: async ({ orgId }: OrgParams) => {
    const { data } = await axiosInstance.get<IncidentTypeItem[]>(ROUTE.MAP_EVENTS.INCIDENT_TYPES, {
      params: { orgId },
    });
    return data;
  },

  getSeverityLevels: async ({ orgId }: OrgParams) => {
    const { data } = await axiosInstance.get<SeverityItem[]>(ROUTE.MAP_EVENTS.SEVERITY_LEVELS, { params: { orgId } });
    return data;
  },

  getIncidentDistinctFieldValues: async ({ orgId, field }: OrgParams & { field: string }) => {
    const { data } = await axiosInstance.get<string[]>(ROUTE.MAP_EVENTS.INCIDENT_DISTINCT_FIELD_VALUES, {
      params: { orgId, field },
    });
    return data;
  },
};
